import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  console.log('htag responseParser', response)
  const data = isSuccessResponse(response)
  return {
    data:
      data?.content?.map((item) => {
        try {
          return JSON.parse(item?.value)
        } catch (e) {
          return item?.value
        }
      }) ?? [],
  }
}

const getAllProcessingEntityConfig = (inputFilter: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getAllProcessingEntityConfig),
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: {
      inputFilter,
      configParams: {
        page: 1,
        size: 10000,
      },
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getAllProcessingEntityConfig }
